/**
 * 製品グループ画像 エンティティ
 */
import { isNud } from '@/utilities/typing';
import ProductGroup from '@/models/entities/product-group';

class ProductGroupImage {
    product_group_image_id;
    product_group;
    file_label;
    file_name;
    file_path;
    thumbnail_path;
    mime_type;
    file_size;
    file_url;
    thumbnail_url;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.product_group_image_id = properties.product_group_image_id ?? null;
        this.product_group = new ProductGroup(properties.product_group);
        this.file_label = properties.file_label;
        this.file_name = properties.file_name;
        this.file_path = properties.file_path;
        this.thumbnail_path = properties.thumbnail_path;
        this.mime_type = properties.mime_type;
        this.file_size = properties.file_size;
        this.file_url = properties.file_url;
        this.thumbnail_url = properties.thumbnail_url;
    }
}

export default ProductGroupImage;
